import Nullstack from 'nullstack';
export default function IconBrandWaze({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-brand-waze",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M6.66 17.52a7 7 0 0 1 -3.66 -4.52c2 0 3 -1 3 -2.51c0 -3.92 2.25 -7.49 7.38 -7.49c4.62 0 7.62 3.51 7.62 8a8.08 8.08 0 0 1 -3.39 6.62"
  }), "   ", Nullstack.element("path", {
    d: "M10 18.69a17.29 17.29 0 0 0 3.33 .3h.54"
  }), "   ", Nullstack.element("circle", {
    cx: "16",
    cy: "19",
    r: "2"
  }), "   ", Nullstack.element("circle", {
    cx: "8",
    cy: "19",
    r: "2"
  }), "   ", Nullstack.element("path", {
    d: "M16 9h.01"
  }), "   ", Nullstack.element("path", {
    d: "M11 9h.01"
  }), " ");
}